import { useEffect, useState } from "react";
import { ShoppingBag } from "lucide-react";
import { URGENCY_NAMES, PACKS } from "@/lib/content";

export const LiveUrgency = () => {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    let timer;
    const show = () => {
      const name = URGENCY_NAMES[Math.floor(Math.random() * URGENCY_NAMES.length)];
      const pack = PACKS[Math.floor(Math.random() * PACKS.length)];
      const mins = Math.floor(Math.random() * 12) + 1;
      setToast({ name, pack: pack.title, mins, id: Date.now() });
      setTimeout(() => setToast(null), 5000);
      timer = setTimeout(show, Math.random() * 7000 + 8000);
    };
    timer = setTimeout(show, 4000);
    return () => clearTimeout(timer);
  }, []);

  if (!toast) return null;

  return (
    <div
      key={toast.id}
      data-testid="live-urgency-toast"
      className="fixed bottom-24 left-4 z-[70] max-w-xs rounded-xl border border-neutral-200 bg-white p-3 shadow-xl lg:bottom-6"
      style={{ animation: "hp-fade-up 0.5s ease" }}
    >
      <div className="flex items-start gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-600">
          <ShoppingBag className="h-5 w-5" />
        </div>
        <div className="text-sm">
          <span className="font-semibold text-neutral-900">{toast.name}</span>
          <span className="text-neutral-600"> bought the {toast.pack}</span>
          <div className="text-xs text-neutral-400">{toast.mins} minutes ago · ✅ Verified</div>
        </div>
      </div>
    </div>
  );
};
